// 📁 utils/date.js
export const formatDateFr = (dateStr, locale = "fr-FR") => {
  if (!dateStr) return "";
  const d = dateStr instanceof Date ? dateStr : new Date(dateStr);
  d.setHours(0, 0, 0, 0); // normalisation

  const formatted = d.toLocaleDateString(locale, {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric"
  });

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
